import { CommonSchemaIds } from '../../schemas/common.const.js';
export const dictionary = {
    schema: {
        [CommonSchemaIds.VISIBLE]: {
            title: 'Visibility',
            options: {
                visible: 'Visible',
                hidden: 'Hidden'
            }
        },
        [CommonSchemaIds.BASE_INTERVAL]: {
            title: 'Interval',
            description: 'Interval of the distribution.',
            abbr: 'Interval',
            cti: 'Provide the requested count interval.'
        },
        [CommonSchemaIds.INTERVAL]: {
            title: 'Interval',
            description: 'Interval of the distribution.',
            abbr: 'Interval',
            cti: 'Provide the requested count interval.'
        }
    }
};
